<template>
  <div class="join-us">
    <div class="join-img">
      <banner-img :type="2" :alt="alt"></banner-img>
    </div>
     <div class="p">
       <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>技术服务</el-breadcrumb-item>
          <el-breadcrumb-item>{{name}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class='join-main'>
         <leftBox class="left" @fromChild="getChild" :navleft="serviceList" :navtype="navtype" :p=ptitle></leftBox>
         <div class="main-right-talented"><westernImmunoblotRight ref="child" :list="rightList"></westernImmunoblotRight></div>
    </div>
    <div class="rightfixed">
        <ul :class="searchBarFixed == true ? 'isFixed' :''">
           <rightFixed></rightFixed>
        </ul>
    </div>
    <Bottom></Bottom>
  </div>
</template>

<script>
import leftBox from "../../components/leftBox"
import rightFixed from "../productCenter/components/rightFixed"
import westernImmunoblotRight from './westernImmunoblot'
import Bottom from '../../components/bottom'
import {mapState, mapActions} from "vuex"
export default {
  name: 'join-us',
  data () {
    return {
      searchBarFixed: false,
      offsetTop: 0,
      navleft:'',
      navtype:"four",
      ptitle:'技术服务',
      rightList:[],
      serviceList:[],
      id:0,
      name:'',
      alt:'百生跃专业技术服务'
    }
  },
  components:{
    Bottom,
    leftBox,
    rightFixed,
    westernImmunoblotRight
  },
  mounted () {
     window.addEventListener('scroll', this.handleScroll)
  },
  methods: {
      handleScroll () {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        var offsetTop = document.querySelector('.rightfixed').offsetTop
        if (scrollTop > offsetTop) {
          this.searchBarFixed = true
        } else {
          this.searchBarFixed = false
        }
      },
      handleClick(){
        this.$refs.child.toggerIndex(0);
      },
      getChild (v) {
        this.id = v
        this.$api.technicalServise.serviceDetail({
          id : v
        }).then(res=>{
          this.rightList = res.data
          this.handleClick()
          if(this.id == res.data.id){
           this.name = res.data.name
          }
        })
      }
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },  
  created() {
       let navleft = this.$store.state.serviceList
       if(this.$route.query.id){
         this.getChild(this.$route.query.id)
      }else{
        if(navleft.length>0){
         this.getChild(navleft[0].id)
       }else{
         this.getChild(1)
       }
      }
     this.$api.technicalServise.serviseList().then((res)=>{
        this.serviceList = res.data
     })
  }
}
</script>

<style lang="less" scoped>
.join-us{
  width: 1920px;
  background: #efefef;
  box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.5); 
  position: relative;
  .rightfixed{
      width: 90px;
      height:230px;
      position: absolute;
      top:550px;
      right:10px;
      .isFixed{
        position:fixed;
        bottom:150px;
        z-index:999;
      }
  }
  .box-one{
      width: 1510px;
      height: 316px;
      background: #f6f6f6;
      margin: auto;
      background: url("../../images/four.png");
  }
   .p{
    font-size: 14px;
    margin: 26px 0px 20px 335px;
    color: #666666;
    height:19px;
    line-height: 19px;
    /deep/.el-breadcrumb__inner.is-link{
      color:#666666;
      font-size: 14px;
      font-family: MicrosoftYaHei;
      font-weight: normal;
    }
    /deep/ .el-icon-arrow-right{
      color:#666666;
    }
    /deep/ .el-breadcrumb__inner{
      cursor: pointer;
    }
  }
  .join-main{
    width: 1510px;
    background: #ffffff;
    margin: auto;
    margin-bottom: 20px;;
    display: flex;
    .left{
      margin-left: 130px;
    }
    .main-right-talented{
      width: 876px;
      background: #ffffff;
      margin-top: 44px;
      margin-left: 61px;
    }
  }
  .join-img{
    width: 100%;
    img{
      width: 1920px;
      height: 300px;
    }
  }
  .five{
    width: 805px;
    height: 49px;
    margin: auto;
    margin-top: 15px;;
    font-size: 14px;
    text-align: center;
    color: #666666;
    line-height: 24px;
    span{
      font-size: 14px;
      text-align: center;
      color: #666666;
      line-height: 24px;
    }
  }
}
</style>